import { Form, Formik, Field, ErrorMessage } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { eyeIconHide, eyeIconShow } from "../../assets/assets";
import httpApiCall from "../../service/api.service";
import { clearPartnerStorage, getMd5Hash, getStorageValue, Regex, setLoginData ,handleInputSpace} from "../../service/shared.service";
import toastr from "../elements/toast";
import Spinner from "react-bootstrap/Spinner";

const NewPassword = ({signIn}:any) => {
  const [sppiner, setSppiner] = useState(false);
    const toastrService = new toastr(true);
  const [reset, setReset] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [imageState, setImageSrc] = useState({
    imgSrc: eyeIconHide,
    showPwd: true
  })
  const [newPwdImageState, setNewPwdImageStateSrc] = useState({
    imgSrc: eyeIconHide,
    showPwd: true
  })
  const imageUpdate = {
    new_pwd: 'new_pwd',
    confirm_pwd: 'confirm_pwd'
  }

  const SignupSchema = Yup.object().shape({
    newPassword: Yup.string().required('Please enter new password')
    .matches(Regex.password_pattern,"Password must contain at least 8 characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character. Spaces are not allowed.")
    .min(Regex.password_min_password_length, `New password must be at least ${Regex.password_min_password_length} characters long`)
    .max(Regex.password_max_password_length, `New password cannot be more than ${Regex.password_max_password_length} characters long`),
    confirmPassword: Yup.string().required('Please enter confirm password').oneOf([Yup.ref('newPassword')], 'New and Confirm password did not match')
    .min(Regex.password_min_password_length, `New password must be at least ${Regex.password_min_password_length} characters long`)
    .max(Regex.password_max_password_length, `New password cannot be more than ${Regex.password_max_password_length} characters long`)
  });

  const resetPassword = (resetData: any) => {
    setSppiner(true);
    const getReset = getStorageValue('reset_password_token',)
    const getEmail = getStorageValue('reset_email',)
    let api = 'change_password';
    const body: any = {
        reset_password_token: getReset,
        partner_email: getEmail,
      new_password: getMd5Hash(resetData.newPassword),
    }
    if (getStorageValue('user_info_data') && getStorageValue('user_info_data').access_token) {
      body['access_token'] = getStorageValue('user_info_data').access_token;
      body['pu_id'] = (getStorageValue('user_info_data').pu_id + '');
      api = 'change_password_reset';
    }
    httpApiCall({ api, type: "post", body }).then((data) => {
      setSppiner(false);
      // console.log(data,"data");
      
        if (data?.is_error == 0) {
            clearPartnerStorage();
            setLoginData(data, 1);
        } else if (data.is_error == 1) {
            toastrService.showError(data.err);
        }
    })
}

  const updateImage = (type: any = imageUpdate.confirm_pwd) => {
    if (type == imageUpdate.new_pwd)  {
      const src = !newPwdImageState.showPwd ? eyeIconHide : eyeIconShow;
      setNewPwdImageStateSrc({
        imgSrc: src,
        showPwd: !newPwdImageState.showPwd
      });
    } else {
      const src = !imageState.showPwd ? eyeIconHide : eyeIconShow;
      setImageSrc({
        imgSrc: src,
        showPwd: !imageState.showPwd
      });
    }
 }

  return (
    <div className="flow-right">
      <div className="signUp">
        <p className="signUp_up">Set New Password</p>
        <p className="signUp_portal">
          Enter registered email to get reset instructions{" "}
        </p>
      </div>
      <div className="sign_form">
        <Formik
          initialValues={reset}
          onSubmit={resetPassword}
          validationSchema={SignupSchema}
        >
          <Form>
            <div className="grouping">
              <label htmlFor="" className="labels_input">
                New Password
              </label>
              <div className="hide_show">
                <Field
                  type={newPwdImageState.showPwd ? "password" : "text"}
                  className="grouping_groups"
                  name="newPassword"
                  onKeyDown={handleInputSpace}
                />
                <img
                    className="eye-icon IMG"
                    alt="icon"
                    onClick={() => {
                      updateImage(imageUpdate.new_pwd);
                    }}
                    src={newPwdImageState.imgSrc}
                  />
                {/* <img className="eye-icon IMG" alt='icon' onClick={() => { updateImage() }} src={imageState.imgSrc} /> */}
              </div>
              <small className="text-danger">
                <ErrorMessage name="newPassword" />
              </small>
            </div>
            <div className="grouping">
              <div className="">
                <label htmlFor="" className="labels_input">
                  Confirm Password
                </label>
                <div className="hide_show">
                  <Field
                    type={imageState.showPwd ? "password" : "text"}
                    className="grouping_groups"
                    name="confirmPassword"
                    onKeyDown={handleInputSpace}
                  />
                  <img
                    className="eye-icon IMG"
                    alt="icon"
                    onClick={() => {
                      updateImage();
                    }}
                    src={imageState.imgSrc}
                  />
                </div>
                <small className="text-danger">
                  <ErrorMessage name="confirmPassword" />
                </small>
              </div>
            </div>
            <div>
              <div className="button_chase">
                <button disabled={sppiner} type="submit" className="loginBtn">
                  Submit
                  {sppiner && <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />}
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default NewPassword;
